export const TABLE_DATA = {
  heading: "Cloud Platforms We Support for Migration",
  tableHeading: ["From", "Target in MOST", "Tools Used"],
  tableData: [
    {
      From: "AWS",
      Target_in_MOST: "EC2 → Nova, S3 → Swift",
      Tools_Used: "CloudEndure, Boto3, Terraform",
    },
    {
      From: "Azure",
      Target_in_MOST: "VM/Disks → Nova/Cinder",
      Tools_Used: "AzCopy, Azure CLI, Custom API",
    },
    {
      From: "GCP",
      Target_in_MOST: "Compute Engine → Nova",
      Tools_Used: "GCP SDK, gsutil, rsync",
    },
  ],
};
